export var getSubHeading = (data, type) => {
  var subHeading = '';
  if (type == 'RADIO') {
    subHeading = data === null || data === void 0 ? void 0 : data.label;
  } else if (type == 'FORM') {
    subHeading = Object.values(data).join(' • ');
  }
  return subHeading;
};